const customization = resolve => require(['@/pages/customization/index.vue'], resolve)
const customizationDetail = resolve => require(['@/pages/customization/detail.vue'], resolve)
export default[
    {
      path: "/customization",
      name: "定制订单",
      component: customization
    },
    {
        path: "/customization/detail",
        name: "定制订单详情",
        component: customizationDetail
    }
]


// WEBPACK FOOTER //
// ./src/router/customization.js